import {
  IRequestService,
  IRequestServiceData, IRequestServicePost, IRequestServicePostData,
  RequestServiceStatus
} from './index'
import {
  Contact,
  IContact,
  IDate,
  ServiceChoice,
  ServiceTypePrice,
  SERVICE_TYPE_NAME_MAX_LENGTH
} from '../../../index'

export class RequestService extends ServiceTypePrice implements IRequestService {
  id: number
  name: string
  readonly type?: ServiceChoice
  readonly status: RequestServiceStatus
  readonly date_event?: IDate
  readonly date_service_from?: IDate
  readonly date_service_to?: IDate
  readonly link?: string
  contact?: IContact
  readonly stripe_product: string
  readonly stripe_price: string

  constructor(data: IRequestServiceData) {
    super(data);
    this.id = data.id || 0
    this.name = data.name
    this.type = data.type
    this.status = data.status || 'new'
    this.date_event = data.date_event
    this.date_service_from = data.date_service_from
    this.date_service_to = data.date_service_to
    this.link = data.link
    let contact = data.contact
    this.contact = contact ? new Contact(contact) : undefined
    this.stripe_product = data.stripe_product
    this.stripe_price = data.stripe_price
  }

  validate(): boolean {
    return super.validate() && this.validateName();
  }

  validateName(): boolean {
    let name = this.name
    return !!name && name.length <= SERVICE_TYPE_NAME_MAX_LENGTH
  }

  update(data?: IRequestServiceData) {
    super.update(data);
    this.name = data?.name || this.name
    let contactData = data?.contact
    if (contactData) {
      let contact = this.contact
      if (contact) {
        contact.update(contactData)
      } else {
        this.contact = new Contact(contactData)
      }
    }
  }

}

export class RequestServicePost implements IRequestServicePost {
  value: string
  contact_ways: number[]
  token: string

  constructor(data: IRequestServicePostData) {
    this.value = data.value || '';
    this.contact_ways = data.contact_ways || []
    this.token = data.token
  }
}
